import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connectRange } from 'react-instantsearch-dom';
import Rheostat from 'rheostat';
import { trackFacetClick } from 'ck-utils/algoliaAnalytics';
import { generateFacetCombinations } from 'ck-utils';
import { FacetContainer } from './FacetContainer';
import styles from './PriceFacet.module.scss';
import './rheostat.global.scss';
import { ProductListingPageContext } from '../context';

const PriceRange = ({ min, max, currentRefinement, refine }) => {
  const { searchState } = useContext(ProductListingPageContext);
  const isRefined = () => {
    const refinedMax = currentRefinement.max;
    const refinedMin = currentRefinement.min;
    return (refinedMax !== max) || (refinedMin !== min);
  };
  const refineInput = (e, type) => {
    const value = Number(e.target.value);
    trackFacetClick({
      facet_type: 'left_menu',
      facet_name: 'price',
      facet_value: `${type}:${value}`,
      facet_combinations: generateFacetCombinations(searchState, 'price')
    });
    return value >= min && value <= max && refine({ [type]: value });
  };
  const refineSlider = (sliderState) => {
    const maxSnap = Math.ceil(sliderState.values[1] / 5) * 5;
    const minSnap = Math.floor(sliderState.values[0] / 5) * 5;
    const maxValue = maxSnap > max ? max : maxSnap;
    const minValue = minSnap < min ? min : minSnap;
    try {
      refine({
        max: maxValue,
        min: minValue,
      });
      trackFacetClick({
        facet_type: 'left_menu',
        facet_name: 'price',
        facet_value: `min:${minValue},max:${maxValue}`,
        facet_combinations: generateFacetCombinations(searchState, 'price')
      });
    } catch (e) {
      /* eslint-disable-next-line no-console */
      console.warn('Error refining price slider', e);
    }
  };
  return min === max ? null : (
    <FacetContainer
      refinedCount={currentRefinement && isRefined() ? 1 : 0}
      label="Price Slider"
      render={() => (
        <>
          <div className={styles.input_container}>
            <input
              type="number"
              className={styles.input}
              placeholder="Min"
              min={min}
              max={max}
              value={currentRefinement.min}
              onChange={(e) => refineInput(e, 'min')}
            />
          &nbsp;-&nbsp;
            <input
              type="number"
              className={styles.input}
              placeholder="Max"
              min={min}
              max={max}
              value={currentRefinement.max}
              onChange={(e) => refineInput(e, 'max')}
            />
          </div>
          <div className={styles.slider_container}>
            <Rheostat
              min={min}
              max={max}
              values={[currentRefinement.min, currentRefinement.max]}
              onChange={refineSlider}
            />
          </div>
        </>
      )}
    />
  );
};

PriceRange.propTypes = {
  currentRefinement: PropTypes.object.isRequired,
  max: PropTypes.number,
  min: PropTypes.number,
  refine: PropTypes.func.isRequired
};

PriceRange.defaultProps = {
  max: null,
  min: null
};

const ConnectedPriceFacet = connectRange(PriceRange);

export const PriceFacet = () => <ConnectedPriceFacet attribute="price" />;
